import { render, staticRenderFns } from "./NegativePoint.vue?vue&type=template&id=211529ea&"
import script from "./NegativePoint.vue?vue&type=script&lang=js&"
export * from "./NegativePoint.vue?vue&type=script&lang=js&"
import style0 from "./NegativePoint.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports